<template>
  <v-dialog
    v-model="dialog"
    max-width="501px"
    max-height="378px"
    @click:outside="ok"
    @keydown.esc="ok"
    persistent
  >
    <v-card style="border-radius: 8px">
      <v-card-text
        style="display: flex; flex-direction: column; padding: 0; margin: 0"
      >
        <div
          class="dialog--title"
          v-if="['CE007', 'CF006'].includes(errorCode)"
        >
          고객사 설정
        </div>
        <div class="dialog--title" v-else>시스템 에러</div>

        <!-- 모달 타이틀 -->
        <div v-if="errorCode === 'CE007'">
          <div class="dialog--content">고객사 설정 실패</div>
          <div class="dialog--paragraph">
            고객사 등록 중 오류가 발생하였습니다<br />
            관리자에게 문의해 주세요.
          </div>
        </div>

        <div v-else-if="errorCode === 'CF006'">
          <div class="dialog--content">고객사 초기 정보 설정 중</div>
          <div class="dialog--paragraph">
            정보를 등록 중입니다. 1~2분 후 다시 시도해 주세요.
          </div>
        </div>
        <div v-else>
          <div class="dialog--content">
            시스템 에러가 발생하였습니다.<br />
            잠시 후 다시 이용해주세요.
          </div>
          <div class="dialog--paragraph">
            계속해서 문제가 발생한다면 고객센터로 문의해주세요.
          </div>
        </div>
        <div
          v-if="!['CE007', 'CF006'].includes(errorCode)"
          style="
            font-size: 16px;
            line-height: 26px;
            color: var(--surface-medium);
            text-align: center;
          "
        >
          에러코드 : {{ errorCode }}
        </div>

        <div
          class="button-container"
          style="margin-top:32px;margin-bottom:40px;"
        >
          <SubmitButton
            width="144px"
            height="48px"
            font-size="20px"
            button-string="확인"
            bg-dim-color="var(--primary-20)"
            bg-color="var(--primary-100)"
            text-dim-color="var(--surface-100)"
            text-color="var(--surface-100)"
            @click="ok"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import SubmitButton from '@/components/SubmitButton.vue';

export default {
  components: {
    SubmitButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    errorCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  computed: {
    ...mapState(['companyPhoneNumber']),
  },
  watch: {
    value(val) {
      this.dialog = val;
    },
  },
  methods: {
    ok() {
      this.$emit('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  &--title {
    text-align: center;
    margin-top: 40px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    text-align: center;
    color: var(--surface-high);
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  &--content {
    margin-top: 24px;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: var(--primary-100);
    text-align: center;
  }
  &--paragraph {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 26px;
    color: var(--surface-high);
    text-align: center;
  }
}
.button-container {
  display: flex;
  margin: auto;
  margin-bottom: 40px;
  padding: 0 30px;
}
</style>
